export default "__VITE_ASSET__BQOIagTo__"